<template>
  <v-navigation-drawer app color="white" v-model="drawerModel"
    overlay-color="white" :permanent="permanent" :temporary="temporary" width="100" class="elevation-4"
    :class="{ hideNavigationPanel: $store.state.isNavBar === true }"
    >
    <div class="d-flex justify-center pt-3 bg-surface-variant topfixed text" fluid style="overflow:hidden;">
      <img src="../assets/icon.svg" width="30px" height="35px" />
 
    </div>

    <v-divider class="ma-2" style="background-color: white"></v-divider>
    <div class="d-flex flex-column">
        <div class="navitems navHeightDefault">
      <v-list class="d-flex align-center flex-column justify-center">
        <v-list-item 
        v-if="$store.state.role.dashboard || checkMultipeActiveRoles(['vgos', 'mesta', 'jobseeker'])" 
        @click="handleButtonClick" 
        :ripple="false" 
        key="Home" 
        to="/" 
        class="d-flex align-center flex-column justify-center"
        color="grey lighten-2"
        >
          <div class="d-flex flex-column align-center justify-center" :class="isNavItemActive('dashboard') ? 'active  blue px-4 py-1': ''" >
              <div class="d-flex align-center justify-center" >
                <img
                  v-if="isNavItemActive('dashboard')"
                  src="../../public/svgs/Dashboard filled.svg" 
                  alt="Dashboard Icon" 
                  style="width: 24px; height: 24px;"
                  />
                <img 
                  v-else 
                  src="../../public/svgs/deash board.svg"

                  alt="Dashboard Icon" 
                  style="width: 24px; height: 24px; color:brown"/>
              </div>
          </div>
    
      <v-tooltip bottom style="z-index: 999">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
               <div class="text-center mt-1">
              <span class="caption text-no-wrap nav-text-ellipsis " :class=" isNavItemActive('dashboard') ? 'active-list-text-color': 'non-active-list-text-color'">Dashboard</span>
            </div>
          </div>
        </template>
        <span >Dashboard</span>
      </v-tooltip>
        </v-list-item>

        <!-- <v-list-item 
        v-if="$store.state.role.dashboard || checkMultipeActiveRoles(['vgos', 'mesta', 'jobseeker'])" 
        @click="handleButtonClick" 
        :ripple="false" 
        key="Home" 
        to="/mixpanel-dashboard" 
        class="d-flex align-center flex-column justify-center"
        color="grey lighten-2"
        >
          <div class="d-flex flex-column align-center justify-center" :class="isNavItemActive('dashboard') ? 'active  blue px-4 py-1': ''" >
              <div class="d-flex align-center justify-center" >
                <img
                  v-if="isNavItemActive('dashboard')"
                  src="../../public/svgs/Dashboard filled.svg" 
                  alt="Dashboard Icon" 
                  style="width: 24px; height: 24px;"
                  />
                <img 
                  v-else 
                  src="../../public/svgs/deash board.svg"

                  alt="Dashboard Icon" 
                  style="width: 24px; height: 24px; color:brown"/>
              </div>
          </div>
    
      <v-tooltip bottom style="z-index: 999">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
               <div class="text-center mt-1">
              <span class="caption text-no-wrap nav-text-ellipsis " :class=" isNavItemActive('dashboard') ? 'active-list-text-color': 'non-active-list-text-color'">MiXpanel Dashboard</span>
            </div>
          </div>
        </template>
        <span >MiXpanel Dashboard</span>
      </v-tooltip>
        </v-list-item> -->

        <v-list-item 
          v-if="$store.state.role.userManagement?.read ||  checkMultipeActiveRoles(['userManagement', 'teacherOnboarding', 'otherAdminOnboarding', 'rolesAndPrivilage'])" 
          @click="handleButtonClick" 
          :ripple="false"
          color="grey lighten-2"
          key="User" 
          to="/users" 

          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('users') ? 'active slider white--text blue px-4 py-1' : ''">
              <img
                v-if="isNavItemActive('users')"
                src="../../public/svgs/users filled.svg" 
                alt="Users Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/users.svg" 
                alt="Users Icon"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('users') ? 'active-list-text-color': 'non-active-list-text-color'">Users</span>
                </div>
              </div>
            </template>
            <span>Users</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item 
          v-if="$store.state.role.campaign?.read"
          @click="handleButtonClick" 
          :ripple="false"
          color="grey lighten-2"
          key="Campaigns" 
          to="/campaign"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('campaigns') ? 'active slider white--text blue px-4 py-1': ''">
              <img
                v-if="isNavItemActive('campaigns')"
                src="../../public/svgs/campaign filled.svg" 
                alt="Campaigns Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/campaign.svg" 
                alt="Campaigns Icon"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('campaigns') ? 'active-list-text-color': 'non-active-list-text-color'">Campaigns</span>
                </div>
              </div>
            </template>
            <span>Campaigns</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item 
          v-if="$store.state.role.assessment?.read"
          @click="handleButtonClick" 
          :ripple="false"
          color="grey lighten-2"
          key="Assessment" 
          to="/static-assessment"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('static-assessment') ? 'active slider white--text blue px-4 py-1': ''">
              <img
                v-if="isNavItemActive('static-assessment')"
                src="../../public/svgs/assessments filled.svg" 
                alt="Assessment Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/assessments.svg" 
                alt="Assessment Icon"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('static-assessment') ? 'active-list-text-color': 'non-active-list-text-color'">Assessment</span>
                </div>
              </div>
            </template>
            <span>Assessment</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item
          v-if="$store.state.role.questionBank?.read"
          @click="handleButtonClick" 
          :ripple="false"
          :disabled="!$store.state.role.questionBank?.read"
          color="grey lighten-2"
          to="/question-bank"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('question-bank') ? 'active slider white--text blue px-4 py-1': ''">
              <img
                v-if="isNavItemActive('question-bank')"
                src="../../public/svgs/question bank filled.svg" 
                alt="Question Bank Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/question bank.svg" 
                alt="Question Bank Icon"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('question-bank') ? 'active-list-text-color': 'non-active-list-text-color'"> Question Bank</span>
                </div>
              </div>
            </template>
            <span>Question Bank</span>
          </v-tooltip>
        </v-list-item>
         <v-list-item 
          v-if="$store.state.role.intervieweeList?.read"
          @click="handleButtonClick" 
          :ripple="false"
          :disabled="!$store.state.role.intervieweeList?.read"
          color="grey lighten-2"
          to="/interviewee-list"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('interviewee-list') ? 'active slider white--text blue px-4 py-1': ''">
              <img
                v-if="isNavItemActive('interviewee-list')"
                src="../../public/svgs/interviewee-list-active.svg" 
                alt="Interviewee List"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/interviewee-list-inactive.svg" 
                alt="Interviewee List"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('interviewee-list') ? 'active-list-text-color': 'non-active-list-text-color'"> Interviewee list</span>
                </div>
              </div>
            </template>
            <span>Interviewee List</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          v-if="$store.state.role.slotApprover?.read"
          @click="handleButtonClick"
          :ripple="false"
          :disabled="!$store.state.role.slotApprover?.read"
          color="grey lighten-2"
          to="/requested-slots"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('requested-slots') ? 'active slider white--text blue px-4 py-1': ''">
              <img
                v-if="isNavItemActive('requested-slots')"
                src="../../public/svgs/schedule-nav-active.svg"
                alt="Slots Requested"
                style="width: 24px; height: 24px;" />
              <img
                v-else
                src="../../public/svgs/schedule-nav-inactive.svg"
                alt="Slots Requested"
                style="width: 24px; height: 24px;" />
            </div>
          </div>

          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class="isNavItemActive('requested-slots') ? 'active-list-text-color': 'non-active-list-text-color'">Slots Requested</span>
                </div>
              </div>
            </template>
            <span>Slots Requested</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          v-if="$store.state.role.candidatesListing?.read"
          @click="handleButtonClick"
          :ripple="false"
          color="grey lighten-2"
          to="/candidate-list"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="mb-1 d-flex align-center justify-center" :class="isNavItemActive('candidate-list') ? 'active slider white--text blue px-4 py-1': ''">
              <img
                v-if="isNavItemActive('candidate-list')"
                src="../../public/svgs/candidateListFilled.svg" 
                alt="Candidate List Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/candidateList.svg" 
                alt="Candidate List Icon"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('candidate-list') ? 'active-list-text-color': 'non-active-list-text-color'">Candidate List</span>
                </div>
              </div>
            </template>
            <span>Candidate List</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item 
          v-if="$store.state.role.rolesAndPrivilage?.read"
          @click="handleButtonClick" 
          :ripple="false"
          color="grey lighten-2"
          key="Roles" 
          to="/roles"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('roles') ? 'active slider white--text blue px-4 py-1': ''" >
              <img
                v-if="isNavItemActive('roles')"
                src="../../public/svgs/roles filled.svg" 
                alt="Role Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/roles.svg" 
                alt="Role Icon"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('roles') ? 'active-list-text-color': 'non-active-list-text-color'">Role</span>
                </div>
              </div>
            </template>
            <span>Role</span>
          </v-tooltip>
        </v-list-item>


        <v-list-item 
          v-if="$store.state.role.masters?.read ||  checkMultipeActiveRoles( ['cluster', 'Brand', 'school', 'board', 'Level', 'Grade', 'subjectCategory', 'subjects', 'skills', 'learningObjective', 'league'])"
          @click="handleButtonClick" 
          :ripple="false"
          color="grey lighten-2"
          to="/masters"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('masters') ? 'active slider white--text blue px-4 py-1': ''">
              <img
                v-if="isNavItemActive('masters')"
                src="../../public/svgs/Masters filled.svg" 
                alt="Masters Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/masters.svg" 
                alt="Masters Icon"
                style="width: 24px; height: 24px;" />
            </div>
          </div>
          
         <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('masters') ? 'active-list-text-color': 'non-active-list-text-color'">Masters</span>
                </div>
              </div>
            </template>
            <span>Masters</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item 
          @click="handleButtonClick" 
          :ripple="false"
          color="grey lighten-2"
          to="/support"
          class="pa-2 d-flex align-center flex-column justify-center">
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex align-center justify-center" :class="isNavItemActive('support') ? 'active slider white--text blue px-4 py-1': ''">
                <img
                v-if="isNavItemActive('support')"
                src="../../public/svgs/support-filled.svg" 
                alt="Masters Icon"
                style="width: 24px; height: 24px;" />
              <img 
                v-else 
                src="../../public/svgs/support.svg" 
                alt="Masters Icon"
                style="width: 24px; height: 24px;" />
            </div>

          </div>
          
          <v-tooltip bottom style="z-index: 999">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="text-center mt-1">
                  <span class="caption text-no-wrap nav-text-ellipsis" :class=" isNavItemActive('support') ? 'active-list-text-color': 'non-active-list-text-color'">Support</span>
                </div>
              </div>
            </template>
            <span>Support</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </div>
    <div class="signout-item">
  <v-list>
  <v-list-item 
        @click="logout" 
        :ripple="false"
        color="grey lighten-2"
        class="pa-2 d-flex align-center flex-column justify-center">
        
        <div class="d-flex flex-column align-center justify-center">
          <div class="d-flex align-center justify-center">
            <img
              src="../assets/Logout.svg" 
              alt="Logout Icon"
              style="width: 24px; height: 24px;" />
          </div>
        </div>
        
        <v-tooltip bottom style="z-index: 999">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <div class="text-center mt-1">
                <span class="caption text-no-wrap non-active-list-text-color" >Logout</span>
              </div>
            </div>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import AuthService from "@/services/AuthService";
const CryptoJS = require("crypto-js");
import { doc, onSnapshot } from "firebase/firestore";
import {db} from '../firebase'
import { liveListenerUnsubscriber} from "../mixins/liveListenerUnsubcriber";
import LogoComponent from "@/components/LogoComponent.vue";
import {roleInfoMixin} from "@/mixins/roleInfoMixin";
export default {
  name: "NavDrawer",
  components: {
    LogoComponent
  },
  mixins: [liveListenerUnsubscriber, roleInfoMixin],
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    permanent: {
      type: Boolean,
      default: true,
    },
    temporary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mini: true,
      windowHeight: window.innerHeight,
      mastersTabOpen: false,
    };
  },
  computed: {
    drawerModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    user() {
      return AuthService.getUser();
    },
    getHeight() {
      return this.windowHeight - 300;
    },
    activeNavKey() {
      const path = this.$route.path;
      const redirectedFrom = this.$route.query.redirectedFrom;

      // 1) Multi-parent pages: the same page is opened from several sections, so
      //    the opener passes ?redirectedFrom=<navKey>. When it is missing (deep
      //    link / refresh) fall back to a sensible default parent, so the nav is
      //    never left blank. `parents` lists the sections allowed to claim it.
      const multiParentPages = [
        { prefix: '/interview-history',         parents: ['campaigns', 'interviewee-list', 'candidate-list'], default: 'campaigns' },
        { prefix: '/schedule-interview-rounds', parents: ['campaigns',  'candidate-list'], default: 'campaigns' },
        { prefix: '/interviewFeedback',         parents: ['campaigns', 'interviewee-list', 'candidate-list'], default: 'interviewee-list' },
        { prefix: '/interviewReport',           parents: ['campaigns', 'interviewee-list', 'candidate-list'], default: 'campaigns' },
        { prefix: '/demoreport',                parents: ['campaigns', 'interviewee-list', 'candidate-list'], default: 'campaigns' },
        { prefix: '/testreport',                parents: ['campaigns', 'interviewee-list', 'candidate-list'], default: 'campaigns' },
      ];
      const multiParent = multiParentPages.find(p => path.startsWith(p.prefix));
      if (multiParent) {
        return multiParent.parents.includes(redirectedFrom)
          ? redirectedFrom
          : multiParent.default;
      }
      const navRoutes = {
        dashboard: [
          '/', '/management-dashboard', '/mixpanel-dashboard', '/volt-dashboard',
          '/trendline-dashboard', '/comparison-dashboard', '/view-chart-data', '/mestaDashboard',
          '/campaignteachersresult', '/campaignjobseekersresult',
          '/teachersappraisal/*', '/teacherspip', '/teacherstbd', '/teachersothers',
          '/jobseekersappraisal', '/jobseekerspip', '/jobseekerstbd', '/jobSeekersOthers',
          '/clusterteachersappraisal/*', '/clusterteacherspip', '/clusterteacherstbd', '/clustercampaignteachersresult',
          '/clusterjobseekersappraisal', '/clusterjobseekerspip', '/clusterjobseekerstbd', '/clustercampaignjobseekersresult',
          '/schoolteachersappraisal/*', '/schoolteacherspip', '/schoolteacherstbd', '/schoolcampaignteachersresult',
          '/schooljobseekersappraisal', '/schooljobseekerspip', '/schooljobseekerstbd', '/schoolcampaignjobseekersresult',
          '/view/*',
        ],
        users: [
          '/users', '/teachers', '/jobseekers', '/create-teacher', '/create-jobseeker',
          '/update-teacher', '/update-jobseeker', '/user-history',
        ],
        campaigns: [
          '/campaign', '/campaignUser', '/CreateCampaign', '/campaignCardFullView/*',
          '/userreport', '/mestacampaignuser',
        ],
        'static-assessment': [
          '/static-assessment*', '/view-static-assessment', '/create-static-assessment',
          '/update-static-assessment', '/edit-static-assessment*', '/assessment*',
        ],
        'question-bank': [
          '/question-bank*', '/psychometry', '/questionPreview',
        ],
        'interviewee-list': [
          '/interviewee-list',
        ],
        'requested-slots': [
          '/requested-slots',
        ],
        'candidate-list': [
          '/candidate-list', '/candidateuserreport',
        ],
        roles: [
          '/roles', '/manageRole', '/update-role', '/roleUser',
        ],
        masters: [
          '/masters', '/clusters', '/brands', '/schools', '/boards', '/levels', '/grades',
          '/subject-category', '/subjects', '/skills', '/lo-banks', '/league',
          '/skills-weightage-thresholds', '/demoTopics', '/audience-roles',
        ],
        support: [
          '/support',
        ],
      };

      for (const navKey in navRoutes) {
        const matched = navRoutes[navKey].some(route =>
          route.endsWith('*') ? path.startsWith(route.slice(0, -1)) : path === route
        );
        if (matched) return navKey;
      }

      // ViewSchoolData is registered by name rather than a stable path (covered
      // by '/view/*' above too — kept as an explicit safety net).
      if (this.$route.name === 'ViewSchoolData') return 'dashboard';

      return '';
    },
  },
  methods: {
    isNavItemActive(item){
      return this.activeNavKey === item
    },

    scrollActiveNavItemIntoView(behavior = 'smooth'){
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          const activeEl = this.$el && this.$el.querySelector('.navitems .active');
          if (activeEl && typeof activeEl.scrollIntoView === 'function') {
            activeEl.scrollIntoView({ behavior, block: 'nearest' });
          }
        });
      });
    },
    adminRolePermission(){
      // console.log("admin method calling")
      // console.log("admin ",this.$store.state.userInfo)

      const userId = this.$store.state.userInfo.id
      // console.log("admin ",userId)

      const docRef = doc(db, "admins", userId); 
      // console.log("admin ",userId)

      let unsubscribe = onSnapshot(docRef, (snapshot) => {
        const data = snapshot.data();
        if (data) {
          // console.log("admin snapshot ",data);
          if(data.roleId)data.role.id = data.roleId;
          this.$store.state.role = data.role;
          AuthService.setUserInfo(data)
          this.$store.dispatch('setUserInfo', data);
        } else {
          this.logout();
            return;
        }
      }, (error) => {
        console.error("Error listening to document changes:", error);
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },

    // handleMastersClick() {
    //   if (this.$route.path === '/clusters' || this.$route.path === '/brands' || this.$route.path === '/boards' || this.$route.path === '/brands' || this.$route.path === '/grades' || this.$route.path === '/league' || this.$route.path === '/levels' || this.$route.path === '/schools' || this.$route.path === '/skills' || this.$route.path === '/subjects' || this.$route.path === '/subject-category' || this.$route.path === '/lo-banks') {
    //     return;
    //   }
    //   this.$router.push("/clusters")

    // },
    handleButtonClick() {
      // Close the "masters" tab when another button is clicked
      this.mastersTabOpen = false;

      // Perform other actions related to the button click
      // ...
    }
  },
  mounted() {
    console.log(this.$store.state.role)

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    setTimeout(this.adminRolePermission, 5000);
    // setTimeout(, 10000);

    this.scrollActiveNavItemIntoView('auto');
  },

  watch: {
    activeNavKey() {
      this.scrollActiveNavItemIntoView('smooth');
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created() {
    // if(this.$store.state.role.createdOn == undefined){
    //   this.logout();
    // }
    var storedItem = AuthService.getRole();
    const decryptedData = CryptoJS.AES.decrypt(storedItem, "sadfsafa").toString(CryptoJS.enc.Utf8);
    var userData = JSON.parse(decryptedData);
    userData.role.id = userData.roleId;
    this.$store.state.role = userData.role;
    this.$store.state.userInfo.id = userData.id
    this.$store.state.userInfo.name = userData.name;
    this.$store.state.userInfo.email = userData.email;
    if (this.$store.state.role.createdOn == undefined) {
      this.logout();
      return;
    }
   else if(this.$store.state.role.league == undefined){
    this.logout();
      return;
   }
  },
};
</script>

<style scoped>

.v-navigation-drawer {
  padding: 0 16px;
}

.fixedBottom {
  position: sticky !important;
  bottom: 0 !important;
  width: 100%;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: unset;
}

.v-list {
  padding: 8px 0;
  img {
    width: 22px;
  }
}

.v-list-item__icon {
  margin: 0;
}

.v-navigation-drawer--mini-variant.v-navigation-drawer--custom-mini-variant .v-list-item, .v-list-item.v-list-item--link {
  min-height: 0;
  margin-bottom: 8px;
  padding: 10px 20px;
  border-radius: 10px;
}

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 48px;
}

.v-navigation-drawer--mini-variant .v-list-item > *:first-child {
  overflow: hidden;
}

.v-list-item__content, .v-list-group__header.v-list-item.v-list-item--link {
  padding: 0;
}

.master-link {
  border-radius: 10px;
}

.masters-list .v-list-item--link {
  min-height: 0;
}

.v-list-item__title {
  margin-left: 10px;
}

.text {
  color: white;
}

.no-ripple .v-ripple {
  display: none !important;
}

.drawerIcon {
  overflow: hidden;
}

.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  margin-bottom: 16px;
}

.maspad {
  padding-right: 60px;
}

.hideNavigationPanel {
  display: none;
}

.v-application .active {
  padding: 11px;
  border-radius: 10px;
}
.v-application .v-list-item--link:before {
  background-color: white;
}

.navHeightDefault{
  height: calc(100vh - 150px); 
}
.navitems {
    display: flex;
    flex-direction: column;
    margin-bottom: auto;
    overflow-y: auto;
    overflow-x: hidden;
  -ms-overflow-style: none; 
  scrollbar-width: none;  
  flex-grow: 1;
}

.navitems::-webkit-scrollbar {
  display: none;
}
.signout-item{
  flex-grow: 0;
  flex-basis: 200px;
}
.active-list-text-color{
    color: var(--blue-01) !important;
}
.non-active-list-text-color{
    color: var(--gray) !important;
}


.nav-text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 65px; /* adjust as needed */
  display: inline-block;
}

</style>


<!-- .drawerIcon{
  color: transparent;
  box-shadow: none;
} -->
